const appendURLSearchParams = (baseUrl, searchParams) => {
    const searchParamsStr = searchParams.toString();
    return searchParamsStr ? `${baseUrl}?${searchParamsStr}` : baseUrl;
};

// Relative Universal Login localised url for brands support
const buildUniversalUrl = (operation, queryParams, href, redirectToQueryParams = {}) => {
    const url = new URL(href);
    const basePath = (url.pathname.match(/^\/[a-z]{2}-[a-z]{2}/) || [''])[0];

    let searchParams = new URLSearchParams(url.searchParams);
    Object.entries(redirectToQueryParams).forEach(([key, value]) =>
        searchParams.append(key, value)
    );

    const searchParamsStr = searchParams.toString() ? `?${searchParams.toString()}` : '';
    const redirectTo = url.pathname + searchParamsStr;

    const newQueryParams = new URLSearchParams({
        ...queryParams,
        redirectTo
    });

    return appendURLSearchParams(`${basePath}/${operation}`, newQueryParams);
};

const marketingPreferencePageType = 'inquiry';
const marketingPreferencePageName = 'node-traveler-property-ui';

const getInquiryLoginUrl = (href, redirectToQueryParams) =>
    buildUniversalUrl(
        'login',
        {
            enable_login: true,
            referrer_page_location: marketingPreferencePageType,
            referrer_page_name: marketingPreferencePageName
        },
        href,
        redirectToQueryParams
    );

export {getInquiryLoginUrl};
